import type { ReactNode, CSSProperties } from 'react';
import type { BlockRegistryEntry } from './defineEntry';
import { blockEditorBoxStyle } from './defineEntry';
import { buttonBlockRegistryEntry } from './button';
import { buttonRowBlockRegistryEntry } from './button-row';
import { dividerBlockRegistryEntry } from './divider';
import { eyebrowBlockRegistryEntry } from './eyebrow';
import { imageBlockRegistryEntry } from './image';
import { socialBlockRegistryEntry } from './social';
import { spacerBlockRegistryEntry } from './spacer';
import { textBlockRegistryEntry } from './text';
import type { BlockRenderProps } from '../render/blocks/types';
import type { BlockSettingsProps } from '../settings/blocks/types';
import type { Block, BlockType } from '../domain/types';

export type { BlockRegistryEntry } from './defineEntry';

export const BLOCK_REGISTRY = {
  text: textBlockRegistryEntry,
  image: imageBlockRegistryEntry,
  button: buttonBlockRegistryEntry,
  divider: dividerBlockRegistryEntry,
  spacer: spacerBlockRegistryEntry,
  social: socialBlockRegistryEntry,
  eyebrow: eyebrowBlockRegistryEntry,
  buttonRow: buttonRowBlockRegistryEntry,
} satisfies Record<BlockType, BlockRegistryEntry>;

export function renderBlock(props: BlockRenderProps): ReactNode {
  return BLOCK_REGISTRY[props.block.type].render(props);
}

export function renderBlockSettings(props: BlockSettingsProps): ReactNode {
  return BLOCK_REGISTRY[props.block.type].renderSettings(props);
}

export function editorBlockBoxStyle(
  block: Block,
  fillColumnImage: boolean,
): CSSProperties | undefined {
  return blockEditorBoxStyle(BLOCK_REGISTRY[block.type], block, {
    fillColumnImage,
  });
}
